<template>
  <Layout :hasPagination="false" :hasBreadcrumbs="false">
    <div class="content">
      <MainTitle class="full-width" :title="this.$router.currentRoute.name"  />
      <HorizontalStepBullets v-if="currentStep > 0" isFullWidth :currentStep="this.currentStep" class="hor-steps" :totalSteps="this.totalSteps" :stepTitles="this.stepTitles"/>
      <ChoiceProduction v-if="currentStep == 0" @productionTypeSelected="gotProductionType"/>
      <ProductionGeneral v-if="currentStep == 1" @finishedStep="gotStepFinish" @receiveData="gotData" @gobackStep="gotStepUndo" :data="receivedData" />

      <!-- <ProductionDHR v-if="currentStep == 2" @finishedStep="gotStepFinish" @receiveData="gotData"  @gobackStep="gotStepUndo" :data="receivedData" />
      <ProductionSubparts v-if="currentStep == 3 && this.receivedData.type == 'Assembly'" @finishedStep="gotStepFinish" @receiveData="gotData"  @gobackStep="gotStepUndo" :data="receivedData" />
      <ProductionQR v-if="currentStep == totalSteps" @finishedStep="gotStepFinish" @gobackStep="gotStepUndo" :data="receivedData" :confirmedDHR="confirmedDHR" /> -->

      <ProductionDHR v-if="(currentStep == 2 && this.receivedData.type != 'Assembly')" @finishedStep="gotStepFinish" @receiveData="gotData"  @gobackStep="gotStepUndo" :data="receivedData" />
      
      <ProductionSubparts v-if="(currentStep == 2 && this.receivedData.type == 'Assembly')" @finishedStep="gotStepFinish" @receiveData="gotData"  @gobackStep="gotStepUndo" :data="receivedData" />
      <ProductionDHR v-if="(currentStep == 3 && this.receivedData.type == 'Assembly')" @finishedStep="gotStepFinish" @receiveData="gotData"  @gobackStep="gotStepUndo" :data="receivedData" />

      <ProductionQR v-if="currentStep == totalSteps" @finishedStep="gotStepFinish" @gobackStep="gotStepUndo" :data="receivedData" :confirmedDHR="confirmedDHR" />
    </div>
  </Layout>
</template>
<script>
// @ is an alias to /src
import Layout from "@/layouts/Dashboard";
import MainTitle from "@/components/base/MainTitle";
import ChoiceProduction from "@/components/production-dhr/ChoiceProduction";
import ProductionGeneral from "@/components/production-dhr/ProductionGeneral";
import ProductionDHR from "@/components/production-dhr/ProductionDHR";
import ProductionSubparts from "@/components/production-dhr/ProductionSubparts";
import ProductionQR from "@/components/production-dhr/ProductionQR";
import HorizontalStepBullets from "@/components/base/HorizontalStepBullets";

export default {
  name: "start-production",
  components: {
    Layout,
    MainTitle,
    ChoiceProduction,
    ProductionGeneral,
    ProductionDHR,
    ProductionSubparts,
    ProductionQR,
    HorizontalStepBullets 
  },
  data () {
    return {
      totalSteps: {
        type: Number,
        default: 4,
      },
      confirmedDHR: '',
      currentStep: 0,
      type: '',
      receivedData: {
        type: '',
        lot: '',
        deviceID: '',
        ref: '',
        realRef: '',
        devDesc: '',
        quantity: 0,
        subparts: [],
        flow: ''
      },
      stepTitles: [],
      postDHRUrl: '',
      lotten: []
    }
  },
  mounted() {
  },
  methods: {
    gotProductionType(type) {
      if(type == 'Assembly') {
        this.totalSteps = 4
        this.stepTitles = ['General', 'Subparts', 'DHR Info', 'QR-Code']
      } else {
        this.totalSteps = 3
        this.stepTitles = ['General','DHR Info', 'QR-Code']
      }
      this.gotData({page: 'type', type: type})
      this.nextStep()
    },
    gotData(object) {
      switch(object.page) {
        case "type":
          this.type = object.type
          this.receivedData.type = object.type
          break;
        case "general":
          this.receivedData.deviceID = object.deviceID
          this.receivedData.lot = object.lot
          this.receivedData.flow = object.flow
          this.receivedData.ref = object.ref
          this.receivedData.devDesc = object.desc
          break;
        case "dhr":
          this.receivedData.quantity = object.quantity
          this.receivedData.matNumber = object.matNumber
          break;
        case "subparts":
          this.receivedData.subparts = object.subparts
          break;
      }
    },
    gotStepFinish(data){
      var that = this
      var lotten = []
      var params

      if(this.receivedData.type == 'Assembly') {
        for (var i = 0; i < this.receivedData.subparts.length; i++) {
          var totalNeeded = this.receivedData.subparts[i].amount * this.receivedData.quantity
          lotten.push({'bonID': this.receivedData.subparts[i].bon, 'amount': totalNeeded, 'deviceRef':this.receivedData.subparts[i].ref})
        }

        params = {
          "lotID": "",
          "flowID": that.receivedData.flow,
          "amount": that.receivedData.quantity,
          "ref": that.receivedData.ref,
          "partID": that.receivedData.deviceID,
          "lotten": lotten,
        }
        this.postDHRUrl = "production/create/dhflot"
      } else {
        params = {
          "bonID": "",
          "isSingle": this.receivedData.type == "Single" ? true : false,
          "flowID": that.receivedData.flow,
          "amount": that.receivedData.quantity,
          matNumber: that.receivedData.matNumber,
          "ref": that.receivedData.ref,
          "partID": that.receivedData.deviceID,
        }
        this.postDHRUrl = "production/create/dhfbon"
      }
      if(this.currentStep == (this.totalSteps-1) ){
        this.$http.post(this.$endpoint + this.postDHRUrl, params
        ).then(function (response) {
          that.confirmedDHR = response.data.result
          if(that.receivedData.type == 'Assembly') {
            that.confirmLOTDHR()
          } else {
            that.confirmBONDHR()
          }
        })
        .catch(function (error) {
          that.$swal(
            'Oops that went wrong?',
            `Something wasn't right, please try again: ${ error }`,
            'error'
          );
        });
      } else {
        this.nextStep()
      }
    },
    confirmLOTDHR(){
      this.$swal(
        'DHR started successfully!',
        `The production and the associated DHR have been successfully added into the system.`,
        'success'
      );
      this.nextStep()
    },
    confirmBONDHR(){
      this.$swal(
        'DHR started successfully!',
        `The production and the associated DHR have been successfully added into the system.`,
        'success'
      );
      this.nextStep()
    },
    gotStepUndo(data){
      this.prevStep()
    },
    prevStep(){
      this.currentStep -= 1
    },
    nextStep(){
      this.currentStep += 1
    }
  },
  watch: {
    type: function(newVal, oldVal) {
      if(newVal != oldVal && oldVal != '') {
        this.receivedData.lot = ''
        this.receivedData.ref = ''
        this.receivedData.devDesc = ''
        this.receivedData.quantity = 0
        this.receivedData.subparts = []
      }
    },
  }
};
</script>
<style lang="scss" scoped>
@import "@/style/base.scss";
@import "@/style/pages/content.scss";
@import "@/style/components/sidebar.scss";

.content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.hor-steps {
  margin-top: 24px;
}

.full-width {
  width: 100%;
}
</style>;
